import { render } from "./RefferalList.vue?vue&type=template&id=16a23345&scoped=true"
import script from "./RefferalList.vue?vue&type=script&lang=js"
export * from "./RefferalList.vue?vue&type=script&lang=js"

import "./RefferalList.vue?vue&type=style&index=0&id=16a23345&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a23345"]])

export default __exports__